import { render } from "./CustomerDetailTableContentLoader.vue?vue&type=template&id=8aca9cee&scoped=true&ts=true"
import script from "./CustomerDetailTableContentLoader.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailTableContentLoader.vue?vue&type=script&lang=ts"

import "./CustomerDetailTableContentLoader.vue?vue&type=style&index=0&id=8aca9cee&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aca9cee"]])

export default __exports__